import { Liquid } from '@ant-design/charts';
import { useTheme } from 'contexts/theme';
import { ORANGE, RED } from 'utils/colors';

export default function Gauge({ percent = 0.35 }: { percent?: number }) {
  const { dark } = useTheme();
  const color = dark ? 'white' : 'black';
  const config = {
    percent,
    height: 200,
    outline: {
      border: 2,
      distance: 2
    },
    wave: { length: 64 },
    liquidStyle: {
      fill: ORANGE
    },
    color: function color() {
      return RED;
    },
    statistic: {
      title: {
        style: {
          fontSize: '12px',
          color: color,
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      content: {
        style: {
          fontSize: '12px',
          color: color,
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      }
    }
  };

  return <Liquid {...config} />;
}
